import React from "react";

import {Button} from "@pg-design/button-module";
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {LeadTopicFormVariant} from "../../ab_testing/ongoing_ab_tests";
import {rpFeatureFlagLeadTopicForm} from "../../app/read_rp_environment_variables";
import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {LeadModalStep} from "../../application/types/LeadModalStep";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {LeadTopicType} from "../../lead/types/LeadTopicType";

export const PropertyDetailDetailsParkingInquiryButtonABTest = (props: {
    vendorId: number;
    offerId: number;
    propertyId: number;
    leadTopicFormAbTestInstance: ReturnType<typeof abTestingInstance.getABTestContainerProps>;
    fallbackRender: React.ReactNode;
}) => {
    const {vendorId, offerId, propertyId} = props;

    const {abTestVariant: leadTopicFormVariant} = useABTest(props.leadTopicFormAbTestInstance);

    if (!rpFeatureFlagLeadTopicForm || leadTopicFormVariant !== LeadTopicFormVariant.VISIBLE) {
        return props.fallbackRender;
    }

    return (
        <ApplicationModalButton
            vendorId={vendorId}
            offerId={offerId}
            propertyId={propertyId}
            source={ApplicationSource.Property}
            sourceSection={ApplicationSourceSection.TABLE}
            initialStep={LeadModalStep.APPLICATION_FORM_WITH_TOPIC}
            topic={{
                type: LeadTopicType.PARKING
            }}
            render={({openModal}) => (
                <Button
                    variant="highlight_primary"
                    size="small"
                    onClick={() =>
                        openModal({
                            clickText: "Zapytaj o dostępność miejsc postojowych",
                            source: "property_detail_table_parking",
                            vendorName: "",
                            offerName: ""
                        })
                    }
                >
                    Zapytaj o dostępność miejsc postojowych
                </Button>
            )}
        />
    );
};
import React from "react";

import {Button} from "@pg-design/button-module";
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {LeadTopicFormVariant} from "../../ab_testing/ongoing_ab_tests";
import {rpFeatureFlagLeadTopicForm} from "../../app/read_rp_environment_variables";
import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {LeadModalStep} from "../../application/types/LeadModalStep";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {LeadTopicType} from "../../lead/types/LeadTopicType";

export const PropertyDetailDetailsParkingInquiryButtonABTest = (props: {
    vendorId: number;
    offerId: number;
    propertyId: number;
    leadTopicFormAbTestInstance: ReturnType<typeof abTestingInstance.getABTestContainerProps>;
    fallbackRender: React.ReactNode;
}) => {
    const {vendorId, offerId, propertyId} = props;

    const {abTestVariant: leadTopicFormVariant} = useABTest(props.leadTopicFormAbTestInstance);

    if (!rpFeatureFlagLeadTopicForm || leadTopicFormVariant !== LeadTopicFormVariant.VISIBLE) {
        return props.fallbackRender;
    }

    return (
        <ApplicationModalButton
            vendorId={vendorId}
            offerId={offerId}
            propertyId={propertyId}
            source={ApplicationSource.Property}
            sourceSection={ApplicationSourceSection.TABLE}
            initialStep={LeadModalStep.APPLICATION_FORM_WITH_TOPIC}
            topic={{
                type: LeadTopicType.PARKING
            }}
            render={({openModal}) => (
                <Button
                    variant="highlight_primary"
                    size="small"
                    onClick={() =>
                        openModal({
                            clickText: "Zapytaj o dostępność miejsc postojowych",
                            source: "property_detail_table_parking",
                            vendorName: "",
                            offerName: ""
                        })
                    }
                >
                    Zapytaj o dostępność miejsc postojowych
                </Button>
            )}
        />
    );
};
